<cm-page>
  <cm-loader></cm-loader>
</cm-page>
